import { render, staticRenderFns } from "./Molded.vue?vue&type=template&id=6b747706&scoped=true&"
import script from "./Molded.vue?vue&type=script&lang=js&"
export * from "./Molded.vue?vue&type=script&lang=js&"
import style0 from "./Molded.vue?vue&type=style&index=0&id=6b747706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b747706",
  null
  
)

export default component.exports